export default __webpack_public_path__ + "9821cd840a7242a500cb19a191dbd2db.png";